import { render, staticRenderFns } from "./ProfessionTaskHubPage.vue?vue&type=template&id=76ee89cc"
import script from "./ProfessionTaskHubPage.vue?vue&type=script&lang=js"
export * from "./ProfessionTaskHubPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports